(function () {
  angular
    .module("akitabox.desktop.inspectionProgram")
    .controller(
      "OrganizationInspectionProgramListController",
      OrganizationInspectionProgramListController
    );

  /** @ngInject */
  function OrganizationInspectionProgramListController(
    // Angular
    $q,
    $location,
    $scope,
    $timeout,
    // Constants
    EVENT_INSPECTION_PROGRAM_CREATE,
    // Filter bar
    FilterBarManager,
    ManagedInspectionProgramAssigneesFilter,
    ManagedModelFieldFilter,
    // Services
    ChecklistTemplateService,
    InspectionProgramService,
    ToastService,
    UserService,
    // Resolve
    organization,
    status
  ) {
    var self = this;
    self.inspectionPrograms = [];
    self.activeFilters = {};
    self.status = status;

    // Functions
    self.fetchInspectionPrograms = fetchInspectionPrograms;
    self.fetchAllInspectionPrograms = fetchAllInspectionPrograms;
    self.changeFilters = changeFilters;

    // Filter Bar
    self.filterBarManager = new FilterBarManager({
      onFilterChange: function () {
        var query = self.filterBarManager.getQuery();
        // apply the static ?status=${status} portion of the query
        query.status = $location.search().status;
        // update the list
        changeFilters(query);
      },
    });

    // Events
    $scope.$on(EVENT_INSPECTION_PROGRAM_CREATE, onInspectionProgramCreate);

    function onInspectionProgramCreate($event, inspectionProgram) {
      if (!self.inspectionPrograms) self.inspectionPrograms = [];
      self.inspectionPrograms.unshift(inspectionProgram);
      $timeout(function () {
        $scope.$broadcast("list:refreshClickEvents");
      });
    }

    var subjectConfig = new ManagedModelFieldFilter(self.filterBarManager, {
      displayName: "Subject",
      queryField: "name",
    });

    var idConfig = new ManagedModelFieldFilter(self.filterBarManager, {
      displayName: "ID",
      queryField: "number",
      inputType: "number",
      prefix: "IP-",
      modelValueToChipText: function (inputValue) {
        return "IP-" + inputValue;
      },
    });

    var priorityConfig = new ManagedModelFieldFilter(self.filterBarManager, {
      displayName: "Priority",
      queryField: "priority",
      inputType: "typeahead",
      getEnumOptions: function () {
        return ["Low", "Medium", "High", "Emergency"];
      },
      modelValueToFilterValue: function (priority) {
        return priority.toLowerCase();
      },
      modelValueToChipText: function (priority) {
        return priority.charAt(0).toUpperCase() + priority.slice(1);
      },
      filterValueToModelValue: function (queryStringValue) {
        return [queryStringValue];
      },
    });

    var UNASSIGNED_USER = {
      _id: "null",
      identity: {
        _id: "null",
        email: null,
        display_name: "Unassigned",
      },
    };

    var assigneesConfig = new ManagedInspectionProgramAssigneesFilter(
      self.filterBarManager,
      {
        getEnumOptions: function () {
          return fetchAssignees().then(function (assignees) {
            const models = assignees.map(function (user) {
              const identity = user.identity;
              let value = user.email;
              if (identity) {
                value =
                  identity.display_name !== identity.email
                    ? identity.display_name + " | " + identity.email
                    : identity.display_name;
              }

              return {
                model: user,
                value: value,
              };
            });

            // Add `Unassigned` as a typeahead option
            models.unshift({
              model: UNASSIGNED_USER,
              value: UNASSIGNED_USER.identity.display_name,
            });

            return models;
          });
        },
        modelValueToFilterValue: function (user) {
          return user._id || user;
        },
        modelValueToChipText: function (user) {
          const identity = user.identity;
          return identity ? identity.display_name : user.email;
        },
        filterValueToModelValue: function (assigneeQueryValue) {
          var models = [];
          // assigneeQueryValue is a string
          var userIdList = assigneeQueryValue.split(",").slice(1);
          // Remove duplicates
          userIdList = userIdList.filter(function (_userId, index) {
            return userIdList.indexOf(_userId) === index;
          });

          var userQueryIds = [];
          for (var i = 0; i < userIdList.length; i++) {
            var userId = userIdList[i];
            if (userId === "null") {
              models.push(UNASSIGNED_USER);
            } else {
              userQueryIds.push(userId);
            }
          }

          if (userQueryIds.length === 0) {
            return models;
          }

          return UserService.getAll(self.organization._id, {
            _id: "$in," + userQueryIds.join(","),
            sort: "firstOrEmail,asc",
          }).then(function (users) {
            Array.prototype.push.apply(models, users);
            return models;
          });
        },
      }
    );

    var checklistConfig = new ManagedModelFieldFilter(self.filterBarManager, {
      displayName: "Checklist Template",
      queryField: "checklist_template",
      // typeahead because we want them to be able to choose the template
      inputType: "typeahead",
      filterValueToModelValue: function (queryStringValue) {
        // We assume the queryStringValue is the id, if not, it'll still be fine as it returns a nothing
        return ChecklistTemplateService.getById(
          organization._id,
          queryStringValue
        ).then(function (template) {
          // we have to return an array type
          return [template];
        });
      },
      getEnumOptions: function () {
        // fn required by typeahead inputTypes.  responsible for grabbing the droopdown values
        return fetchChecklistTemplates().then(function (templates) {
          return templates.map(function (template) {
            return {
              model: template,
              value: template.name,
            };
          });
        });
      },
      modelValueToChipText: function (template) {
        // fn to determine what text is shown on the filter's chip
        return template.name;
      },
      modelValueToFilterValue: function (template) {
        // fn to determine what value is sent to the API when filtering by checklist templates
        return template._id;
      },
    });

    [
      subjectConfig,
      idConfig,
      priorityConfig,
      assigneesConfig,
      checklistConfig,
    ].forEach(function (config) {
      self.filterBarManager.addFilterConfiguration(config);
    });

    self.filterInitPromise = self.filterBarManager.applyQuery(
      $location.search()
    );

    // ------------------------
    //   Public Functions
    // ------------------------

    function fetchInspectionPrograms(skip, limit) {
      var doFetch = function () {
        var params = {
          skip: skip,
          limit: limit,
        };
        var paramsAndFilters = angular.extend({}, params, self.activeFilters);

        return InspectionProgramService.getByOrganization(
          organization._id,
          paramsAndFilters
        )
          .then(function (inspectionPrograms) {
            if (angular.isArray(self.inspectionPrograms)) {
              self.inspectionPrograms =
                self.inspectionPrograms.concat(inspectionPrograms);
            } else {
              self.inspectionPrograms = inspectionPrograms;
            }
            return inspectionPrograms.length;
          })
          .catch(ToastService.showError);
      };
      return $q.resolve(self.filterInitPromise).then(doFetch);
    }

    function fetchAllInspectionPrograms(limit) {
      var doFetch = function () {
        var params = {
          limit: limit,
        };

        return InspectionProgramService.getAllByOrganization(
          organization._id,
          params
        )
          .then(function (inspectionPrograms) {
            self.inspectionPrograms = inspectionPrograms;
            return inspectionPrograms.length;
          })
          .catch(ToastService.showError);
      };
      return $q.resolve(self.filterInitPromise).then(doFetch);
    }

    function changeFilters(activeFilters) {
      $location.search(activeFilters).replace();
      self.activeFilters = angular.isEmpty(activeFilters, true)
        ? null
        : activeFilters;
      self.inspectionPrograms = [];
      $scope.$broadcast("list:refresh");
    }

    // -----------------------
    //    Private Functions
    // ------------------------

    function fetchAssignees() {
      return UserService.getAll(organization._id, {
        identity: "$ne,null",
        sort: "firstOrEmail,asc",
      }).catch(ToastService.showError);
    }

    /**
     * fetches all checklist templates within this org
     */
    function fetchChecklistTemplates() {
      var params = {};
      if (self.status === "active") {
        params.status = "active";
      }
      return ChecklistTemplateService.getAll(organization._id, params).catch(
        ToastService.showError
      );
    }
  }
})();
